<template>
  <div class="appTable">
    <div class="appTable__tool" v-if="showTopControl">
      <div class="appTable__tool__left">
        <el-button-group>
        </el-button-group>

        <slot name="tools"></slot>
        <slot name="third"></slot>
      </div>
      <div class="appTable__tool__right">
        <el-button
          type="primary"
          :icon="isFilter ? 'el-icon-receiving' : 'el-icon-files'"
          :title="isFilter ? '收起筛选选项' : '更多筛选选项'"
          @click="doFilter"
        ></el-button>

        <el-input v-model="searchword" placeholder="快速搜索内容" @change="onSWChanged">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <el-collapse-transition>
      <!-- 状态显示 -->
      <div class="appTable_tool_filter" v-show="isFilter">
        <template v-if="FilterStatusDefault && packup">
          <selectTableFilterStatus
            ref="selectTableFilterStatus"
            :showReviewOption="showReviewOption"
            :showDealOption="showDealOption || showDeal"
            @onDataChanged="onTableFilterStatusDataChanged"
          ></selectTableFilterStatus>
        </template>
        <slot name="filter"></slot>
        <slot name="secondFilter"></slot>
        <slot name="thirdFilter"></slot>
      </div>
    </el-collapse-transition>
    <div class="appTable__tool__fixed">
      <slot name="fixedFilter"></slot>
    </div>

    <!-- 默认的Table控件 -->
    <el-table
      :data="datas"
      stripe
      border
      class="appTable__datas"
      header-row-class-name="table-header-row"
      v-loading="loadingTable"
    >
      <template v-if="expand">
        <el-table-column type="expand">
          <template slot-scope="props">
            <slot name="expand" :props="props"></slot>
          </template>
        </el-table-column>
      </template>

      <el-table-column
        type="index"
        width="50">
      </el-table-column>

      
      
      <template v-for="item in columns">

        <template v-if="item.scope">
          <el-table-column
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <slot name="columnSlotFirst" :props="scope"></slot>
            </template>
          </el-table-column>
        </template>
        <template v-if="!item.scope">
          <!-- 设置时间 -->
          <template v-if="item.prop == 'cdate'">
            <el-table-column
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
            >
              <template slot-scope="scope">
                {{ dateFormat("YYYY-mm-dd HH:MM:SS", scope.row.cdate) }}
              </template>
            </el-table-column>
            <!-- <template slot-scope="scope">
                  {{dateFormat("YYYY-mm-dd",scope.row.cdate)}} 1111
                </template>                 -->
          </template>

          <template v-else-if="item.convert">
              <el-table-column
                :label="item.label"
                :width="item.width"            
              >
                <template #default="scope">
                  <!-- <p>{{item.convert(scope.row.prop)}}</p>            -->
                  <p>{{item.convert(scope.row[item.prop])}}</p>           
                </template>
              </el-table-column>        
          </template>

          <template v-else-if="item.convertRow">
              <el-table-column
                :label="item.label"
                :width="item.width"            
              >
                <template #default="scope">
                  <!-- <p>{{item.convert(scope.row.prop)}}</p>            -->
                  <p>{{item.convertRow(scope.row)}}</p>           
                </template>
              </el-table-column>        
          </template>

          <template v-else>
            <el-table-column
              :prop="item.prop"
              :label="item.label"
              :key="item.prop"
              :width="item.width"
            >
            </el-table-column>
          </template>
        </template>
      </template>

      <el-table-column
        label="当前状态"
        width="100px"
        v-if="packup && showTopControl"
      >
        <template slot-scope="scope">
          <StatusTag
            :status="scope.row.status"
            :showReviewOption="showReviewOption"
          ></StatusTag>
          <!-- <el-tag
          :type="getTableStatusClass(scope.row.status)">{{scope.row.statusStr}}</el-tag>-->
          <!-- <p :class="getTableStatusClass(scope.row.status)">{{scope.row.statusStr}}</p> -->
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" class-name="column__tool">
        <template slot-scope="scope">
          <template v-if="tableToolConfig.canRecover">
            <StartTableBtn
              v-if="scope.row.status == 1"
              :serverUrl="serverUrl"
              :id="scope.row.id"
              :title="scope.row.title || scope.row.name || scope.row.username"
              @onSuccess="onToolSuccess"
            ></StartTableBtn>
          </template>
          <template v-if="tableToolConfig.canEdit">
            <router-link
              :to="{ path: baseUrl + '/edit', query: { id: scope.row.id } }"
            >
              <!-- 显示处理 -->
              <template v-if="showReviewOption">
                <!-- 未启用，审核失败，启用中都可以修改 -->
                <el-button
                  type="primary"
                  size="mini"
                  v-if="
                    scope.row.status == 1 ||
                    scope.row.status == 4 ||
                    scope.row.status == 0
                  "
                  plain
                  icon="el-icon-edit"
                  class="column__tool__buttom"
                  >修改&nbsp;</el-button
                >
              </template>

              <template v-else>
                <!-- 只要不是删除，都可以修改 -->
                <el-button
                  type="primary"
                  size="mini"
                  v-if="scope.row.status != 2 && scope.row.status != 3"
                  plain
                  icon="el-icon-edit"
                  class="column__tool__buttom"
                  >修改&nbsp;</el-button
                >
              </template>
            </router-link>
          </template>
          <template v-if="tableToolConfig.canDelete">
            <DeleteTableBtn
              v-if="scope.row.status == 1"
              :serverUrl="serverUrl"
              :id="scope.row.id"
              :title="scope.row.title || scope.row[titleProp]"
              @onSuccess="onToolSuccess"
            ></DeleteTableBtn>
          </template>
          <template v-if="tableToolConfig.canDisable">
            <DisableTableBtn
              v-if="scope.row.status == 0"
              :serverUrl="serverUrl"
              :id="scope.row.id"
              :title="scope.row.title || scope.row[titleProp]"
              @onSuccess="onToolSuccess"
            ></DisableTableBtn>
          </template>

          <template v-if="showDealOption">
            <router-link
              :to="{ path: baseUrl + '/deal', query: { id: scope.row.id } }"
            >
              <!-- 审核 -->
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.status == 3 || scope.row.status == 4"
                plain
                icon="el-icon-edit"
                class="column__tool__buttom"
                >处理&nbsp;</el-button
              >
            </router-link>
          </template>
          <template v-if="showDeal && scope.row.status == 3">
            <el-button
              type="primary"
              size="mini"
              plain
              icon="el-icon-edit"
              class="column__tool__buttom"
              >查看审核状态&nbsp;</el-button
            >
            <el-button
              type="info"
              size="mini"
              plain
              icon="el-icon-close"
              class="column__tool__buttom"
              >取消审核&nbsp;</el-button
            >
          </template>
          <slot name="bindInfo" :data="scope.row"></slot>
          <slot name="columnSlotTool" :props="scope.row.id"></slot>
        </template>
      </el-table-column>
    </el-table>

    <div class="appTable__footer">
      <div class="appTable__footer_page">
        <el-pagination
          :pager-count="5"
          class="el-pag"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page_size"
          layout="sizes,total,next, pager,prev,jumper "
          :total="total"
        ></el-pagination>
      </div>
      <div class="appTable__footer__info">
        <p>
          <i class="el-icon-info mr-1"></i>
          <slot name="table__footer__info"></slot>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { dateFormat } from "@/utils/index";
import { getListApi } from "@/api/core/table/table";

import { selectTableFilterStatus } from "../select";
import {
  StatusTag,
  DisableTableBtn,
  StartTableBtn,
  DeleteTableBtn,
} from "./comp";
import { getPageData,cachePage,cacheSize,cachePageData} from "@/utils/tablestorage";

export default {
  name: "CoreTableContainer",
  
  mixins: [BaseVue],
  
  components: {
    selectTableFilterStatus,
    StatusTag,
    DisableTableBtn,
    StartTableBtn,
    DeleteTableBtn,
  },
  
  props: {
    // api 默认地址
    serverUrl: {
      type: String,
      default: ""
    },
    // 表格列配置
    columns: {
      type: Array,
      default: () => []
    },
    // 表格工具配置
    tableToolConfig: {
      type: Object,
      default: () => ({})
    },
    // 是否使用默认排序
    FilterStatusDefault: {
      type: Boolean,
      default: true
    },
    // 表单首选项是否打开
    expand: {
      type: Boolean,
      default: false
    },
    // 状态是否显示
    packup: {
      type: Boolean,
      default: true
    },
    // baseurl
    baseUrl: {
      type: String,
      default: ""
    },
    // 显示审核的选项
    showReviewOption: {
      type: Boolean,
      default: false
    },
    // 显示审核中的选项
    showDealOption: {
      type: Boolean,
      default: false
    },
    // 显示审核中的选项
    showDeal: {
      type: Boolean,
      default: false
    },
    // 自动初始化
    autoInit: {
      type: Boolean,
      default: true
    },
    // 搜索属性
    searchProp: {
      type: String,
      default: ""
    },
    // 是否显示顶部控件
    showTopControl: {
      type: Boolean,
      default: true
    },
    // 是否拼接list
    splice: {
      type: Boolean,
      default: true
    },
    // 标题属性
    titleProp: {
      type: String,
      default: ""
    }
  },
  
  data() {
    return {
      isFilter: true, // 是否展开更多筛选项
      isRefreshing: false,
      loadingTable: false, // 正在加载表单
      
      datas: [], // table 数据
      
      // filter params
      searchword: "", // 搜索关键字
      status: 0,
      pageTypy: -1,
      dataMap: null, // 数据 map
      
      // 外部传入的筛选值
      sid: "",
      cid: "",
      pid: "",
      partyid: "",
      unitid: "",
      
      // 第一步
      areaId: "",
      // 城市ID
      cityId: "",
      
      // 新闻类型
      type: "",
      stype: "",
      // 审批配型
      key: "",
      
      ccpid: -1,
      checkid: -1,
      
      // 分页
      currentPage: 1,
      page_size: 10,
      total: 0
    };
  },
  
  methods: {
    dateFormat(fmt, date) {
      return dateFormat(fmt, date);
    },
    
    initTable() {
      const _this = this;

      let pageData = getPageData(this.$route.name)
      let pageVal = pageData.page;
      let pageSizeVal = pageData.size;
      
      
      const tableFilterData = {
        pid: _this.pid,
        sid: _this.sid,
        cid: _this.cid,
        unitid: _this.unitid,
        partyid: _this.partyid,
        splice: this.splice,
        ccpid: _this.ccpid,
        checkid: _this.checkid,
        // 第二步
        areaId: _this.areaId,
        cityId: _this.cityId,
        type: _this.type,
        stype: _this.stype,
        key: _this.key,
        status: _this.status,
        searchword: _this.searchword,
        searchProp: _this.searchProp,
        dataMap: this.dataMap,
      };
      
      const start = (pageVal - 1) * pageSizeVal;
      const tablePageData = {
        current: pageVal,
        start: start,
        size: pageSizeVal,
      };
      
      _this.loadingTable = true;
      
      getListApi(_this.serverUrl, tableFilterData, tablePageData)
        .then((response) => {
          const total = response.total;
          let datas;
          if (response.records) {
            datas = response.records;
          } else if (response.datas) {
            datas = response.datas;
          } else {
            datas = response;
          }
          _this.datas = datas;
          _this.total = total;
          
        })
        .finally(() => {
          _this.loadingTable = false;

          this.currentPage = pageVal;
          this.page_size = pageSizeVal;
        })
        ;
    },
    
    DoInit() {
      // 恢复默认
      this.page_size = 10;
      this.currentPage = 1;
      this.searchword = "";
      this.status = 0;
      this.initTable();
    },
    
    doFilter() {
      this.isFilter = !this.isFilter;
    },
    
    onToolSuccess() {
      this.initTable();
    },
    
    // 外部筛选框输入
    updateParams(pkey, pval) {
      if (!this.dataMap) {
        this.dataMap = new Map();
      }
      
      this.dataMap.set(pkey, pval);
      
      const mapJson = JSON.stringify(Object.fromEntries(this.dataMap));
      localStorage.setItem(this.$route.name + "dataMap", mapJson);
      
      this.currentPage = 1;
      localStorage.setItem(this.$route.name + "current", this.currentPage.toString());
      
      this.initTable();
    },
    
    undataCid(cid) {
      this.cid = cid;
      this.initTable();
    },
    
    updateSid(sid) {
      this.sid = sid;
      this.initTable();
    },
    
    updatePid(pid) {
      this.pid = pid;
      this.initTable();
    },
    
    updatePartyid(partyid) {
      this.partyid = partyid;
      this.initTable();
    },
    
    updateUnitid(unitid) {
      this.unitid = unitid;
      this.initTable();
    },
    
    // 更新所属地区
    updateRegionid(areaId) {
      this.areaId = areaId;
      this.initTable();
    },
    
    updateCityid(cityId) {
      this.cityId = cityId;
      this.initTable();
    },
    
    updateType(type) {
      this.type = type;
      this.initTable();
    },
    
    updateStype(stype) {
      this.stype = stype;
      this.initTable();
    },
    
    updateInformationType(type) {
      this.type = type;
      this.initTable();
    },
    
    updateApproveKey(key) {
      this.key = key;
      this.initTable();
    },
    
    updateCcpid(ccpid) {
      this.ccpid = ccpid;
      this.initTable();
    },
    
    updateCheckid(checkid) {
      this.checkid = checkid;
      this.initTable();
    },
    
    onSWChanged() {
      localStorage.setItem(this.$route.name + "current", this.currentPage.toString());
      this.initTable();
    },
    
    // 分页
    handleSizeChange(p) {
      this.page_size = p;

      cachePageData(this.$route.name,this.currentPage,this.page_size);

      this.initTable();
    },
    
    handleCurrentChange(p) {
      this.currentPage = p;
      cachePageData(this.$route.name,this.currentPage,this.page_size);
      this.initTable();
    },
    
    // 状态选择框/所属学习班改动
    onTableFilterStatusDataChanged(value) {
      this.status = value;
      this.currentPage = 1;
      
      cachePageData(this.$route.name,this.currentPage,this.page_size);

      
      this.initTable();
    }
  },
  
  mounted() {
    if (this.autoInit && this.packup) {
      this.initTable();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
